import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const StarRating = ({ rating, onChange, readOnly = false, size = 28 }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const activeRating = hoverRating || rating;

  return (
    <div 
      className="flex items-center space-x-1 rtl:space-x-reverse"
      onMouseLeave={() => !readOnly && setHoverRating(0)}
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const isActive = star <= activeRating;
        const isHover = !readOnly && hoverRating === star && !rating;
        
        return (
          <button
            key={star}
            type="button"
            disabled={readOnly}
            onClick={() => !readOnly && onChange && onChange(star)}
            onMouseEnter={() => !readOnly && setHoverRating(star)}
            className={twMerge(
              clsx(
                "transition-all duration-300 ease-out focus:outline-none disabled:cursor-default disabled:opacity-100",
                isActive ? "text-amber-400" : "text-gray-300 dark:text-gray-600",
                !readOnly && "hover:scale-110",
                // Lobab Gold Glow Effect
                isActive && !readOnly && "drop-shadow-[0_0_8px_rgba(251,191,36,0.6)]"
              )
            )}
          >
            <Star
              size={size}
              weight={isActive ? "fill" : "regular"}
              className={twMerge(
                clsx(
                  "transition-all duration-300",
                  isActive ? "fill-amber-400" : "fill-transparent"
                )
              )}
            />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
